export default __webpack_public_path__ + "static/media/2.959cede5.svg";